import { type ModuloSezioneDTO } from '@framework/api-client/api/inquiries/schemas/moduloSezioneDTO.ts';
import { t } from '@framework/i18n/intl/i18next.ts';

/**
 * Titolo visualizzato di una sezione modulo. Condiviso tra il menu della
 * richiesta e il riepilogo allegati raggruppato per sezione, così che le due
 * viste restino allineate se la logica cambia. Usa `titoloAbbreviato`, poi
 * `nome`, infine un fallback numerato basato sulla posizione della sezione.
 */
export function getSectionTitle(
  section: ModuloSezioneDTO | null | undefined,
  i: number,
) {
  return (
    section?.sezione?.ultimaVersione?.titoloAbbreviato ??
    section?.sezione?.ultimaVersione?.nome ??
    t('submission-menu-items.sezione', 'Sezione {{index}}', {
      index: i + 1,
    })
  );
}
